import { ReduxState } from 'src/store/types';

/**
 * Whether the current user has read-only (viewer / demoted-editor) access to a
 * collaborative cloud project. Mirrors the per-connection `readOnly` flag that
 * the collaboration provider plumbs into the `collaboration` slice on
 * authentication. `projectId` may be `undefined` (e.g. before the route param
 * resolves), in which case the project is treated as editable.
 */
export const isProjectReadOnlySelector =
  (projectId: string | undefined) =>
  (state: ReduxState): boolean =>
    projectId
      ? state.collaboration.readOnlyByProjectId[projectId] ?? false
      : false;
